import React from 'react';
import { useNavigate } from 'react-router';
import bem from 'utils/bem';
import Text from 'components/Text';
import Icon from 'components/Icon';
import LoginFormModal from 'forms/forms/LoginForm/Modal';
import ResetPasswordFormModal from 'forms/forms/ResetPasswordForm/Modal';

import './index.sass'
import Loader from 'components/Loader';

const { cnBlock, el } = bem('page');

export const GoBack = () => {
    const navigate = useNavigate();
    const goBack =
        window.history.state && window.history.state.idx > 0 ?
            () => navigate(-1) :
            () => navigate('/', { replace: true });

    return (
        <div className={ el('go-back') } onClick={ goBack }>
            <Icon name='arrow-left'/>
            <Text>Вернуться назад</Text>
        </div>
    )
}

const Page = ({ className, children, title = null, subtitle = null, key = null, showHeader = true, loading = false }) => {
    return <div className={ cnBlock(className, { loading }) } key={key}>
        <div className={ el('top')}>
            <div className={ el('bg') }/>
            { showHeader && <div className={ el('header') }>
                <GoBack />
            </div> }
            { title && <div className={ el('title') }>
                <Text serif>{title}</Text>
            </div> }
            { subtitle && <div className={ el('subtitle')}>
                <Text serif>{subtitle}</Text>
            </div> }
        </div>
        <div className={ el('bottom')}>
            <div className={ el('content') }>
                { loading ? <Loader /> : children }
            </div>
        </div>
    </div>
};

export default Page;
